<template>
  <div id="app">
    <router-view :key="key"/>
  </div>
</template>
<script>
export default {
  name: 'App',
  computed: {
    key() {
      return this.$route.name !== undefined ? this.$route.name + +new Date() : this.$route + +new Date()
    }
  }
}
</script>
<style lang="less">
@import url('@/assets/fontIcon/iconfont.css');
</style>
